/* Under the Castle — opening animation
 *
 * Faithful port of the Figma storyboard (file 7vVmmLMGrXHLzzTGFtFNrV):
 * a light texture sweeps across the logo in six left-to-right passes
 * (top band to bottom band, 48 storyboard frames ≈ 4s), clipped inside
 * the logo silhouette — exactly how the Figma "Mask group" is built.
 * Wherever the light has passed, the mossy-green logo stays revealed.
 * Afterwards: COMING SOON + button fade in; the light then follows the
 * pointer (hue shifts with position) and the logo edge-glows on hover.
 *
 * Rendering is a 2D-canvas composite (no WebGL) and only draws frames
 * while something is actually animating.
 */
(function () {
  'use strict';

  var ASSETS = 'assets/web/';
  // Native pixel size of the logo plate (Figma node 未标题-1, 1199×848 + bleed)
  var LW = 1208, LH = 856;
  // The light texture is drawn at Figma-storyboard size, relative to the plate
  var LIGHT_W = 1180, LIGHT_H = 834;
  // Figma stores light positions relative to the 1920×1080 frame; the logo
  // plate sits at (412, 63) with ~4px export bleed. Plate-local = design + OFF.
  var OFF_X = -408, OFF_Y = -59;
  // Six sweep bands digitised from storyboard frames 1–48 (design coords).
  var ROWS = [-390, -280, -30, 230, 380, 540];
  var SWEEP_X0 = -709, SWEEP_X1 = 1150;
  // Bright core of the light texture (measured luminance centroid) — the
  // pointer aims this point, so the glow centre sits exactly on the mouse.
  var BLOB_X = 0.50, BLOB_Y = 0.54;

  var stage = document.getElementById('stage');
  // on Shopify each asset lives at its own CDN URL — the section passes a
  // {filename: url} map via data-asset-map; locally we fall back to ASSETS/
  var ASSET_MAP = {};
  try { ASSET_MAP = JSON.parse(stage.dataset.assetMap || '{}'); } catch (e) {}
  var ctx = stage.getContext('2d');
  // only the subscribe bar is guaranteed — everything else on the page
  // is strictly what the design contains
  var ui = {
    coming: document.getElementById('subscribe'),
    btn: document.getElementById('enter-btn'),
    hint: document.getElementById('skip-hint')
  };
  var uiEls = [ui.coming, ui.btn].filter(Boolean);

  // if GSAP failed to load (CDN/asset outage), reveal the static page and bail
  if (!window.gsap) {
    uiEls.forEach(function (el) {
      el.style.opacity = 1;
      el.style.visibility = 'visible';
    });
    if (ui.hint) ui.hint.style.opacity = 0;
    return;
  }

  // 字体就绪门槛:正版 Bodoni 加载完成前隐藏订阅框文字,
  // 防止 fallback 宽体在慢网/Safari 下撑爆边框(2.5s 超时兜底放行)
  (function () {
    var form = document.getElementById('subscribe');
    if (!form) return;
    form.classList.add('fonts-pending');
    var release = function () { form.classList.remove('fonts-pending'); };
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(release);
    }
    setTimeout(release, 2500);
  })();

  // ================================================================
  // 移动端(手机/平板,触摸设备):不跑 canvas 动画,改播客户录制的
  // 动画视频做全屏背景(按屏幕比例四选一),订阅框 3 秒渐显。
  // ================================================================
  var isMobile = window.matchMedia('(pointer: coarse)').matches || /[?&]mobile=1/.test(location.search);
  if (isMobile) {
    stage.style.display = 'none';
    var MV_MAP = {};
    try { MV_MAP = JSON.parse(stage.dataset.mvMap || '{}'); } catch (e) {}
    var CANDS = [
      { r: 608 / 1280,  key: 'port-phone'  },
      { r: 960 / 1280,  key: 'port-tablet' },
      { r: 1280 / 928,  key: 'land-tablet' },
      { r: 1280 / 592,  key: 'land-phone'  }
    ];
    function pickSrc() {
      var ratio = window.innerWidth / window.innerHeight;
      var best = CANDS[0], bd = Infinity;
      for (var i = 0; i < CANDS.length; i++) {
        var d = Math.abs(Math.log(ratio / CANDS[i].r));
        if (d < bd) { bd = d; best = CANDS[i]; }
      }
      return MV_MAP[best.key] || ('assets/mobile-video/utc-mv-' + best.key + '.mp4');
    }
    var vid = document.createElement('video');
    vid.muted = true;
    vid.setAttribute('muted', '');
    vid.setAttribute('playsinline', '');
    vid.setAttribute('webkit-playsinline', '');
    vid.autoplay = true;
    vid.preload = 'auto';
    vid.src = pickSrc();
    vid.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000;';
    // 播完停在最后一帧(动画结尾即定格),不循环
    var intro = document.getElementById('intro');
    intro.insertBefore(vid, intro.firstChild);
    var tryPlay = function () { var p = vid.play(); if (p && p.catch) p.catch(function () {}); };
    tryPlay();
    vid.addEventListener('loadedmetadata', tryPlay);
    vid.addEventListener('canplay', tryPlay);
    // 微信内置浏览器(iOS/安卓)禁手势外 autoplay——JSBridge 就绪通道是唯一可靠解法
    var wxPlay = function () {
      try { WeixinJSBridge.invoke('getNetworkType', {}, tryPlay); } catch (e) { tryPlay(); }
    };
    if (window.WeixinJSBridge) wxPlay();
    else document.addEventListener('WeixinJSBridgeReady', wxPlay, false);
    // iOS 低电量模式等其余场景——首次触摸兜底重播
    var touchPlay = function () { if (vid.paused) tryPlay(); };
    document.addEventListener('touchstart', touchPlay, { passive: true });
    document.addEventListener('touchend', touchPlay, { passive: true });
    vid.addEventListener('playing', function () {
      document.removeEventListener('touchstart', touchPlay);
      document.removeEventListener('touchend', touchPlay);
    });

    // 订阅框:居中,约 78% 高度,宽度自适应(封顶 333px)
    function mLayout() {
      var vw = window.innerWidth, vh = window.innerHeight;
      var uiBox = document.getElementById('ui');
      if (!uiBox) return;
      var bw = Math.min(vw * 0.86, 333);
      var bh = bw / 3.857;
      uiBox.style.left = (vw / 2 - bw / 2) + 'px';
      uiBox.style.top = (vh * 0.78 - bh / 2) + 'px';
      uiBox.style.width = Math.round(bw) + 'px';
      uiBox.style.height = Math.round(bh) + 'px';
      uiBox.style.transform = 'none';
      var subInput = document.getElementById('sub-input');
      if (subInput) subInput.style.fontSize = Math.max(13, Math.round(21 * bw / 333)) + 'px';
    }
    mLayout();
    window.addEventListener('resize', mLayout);
    window.addEventListener('orientationchange', function () {
      setTimeout(function () { mLayout(); vid.src = pickSrc(); tryPlay(); }, 250);
    });
    // 订阅框跟随视频里"背景升起"的时刻一起出现(约视频 62% 处,
    // 三个正式视频实测升起点 6.7~7.3s)——客户要求框和背景同时现身
    gsap.set(ui.coming, { autoAlpha: 0 });
    var barShown = false;
    var showBar = function () {
      if (barShown) return;
      barShown = true;
      gsap.to(ui.coming, { autoAlpha: 1, duration: 1.1, ease: 'power2.inOut' });
    };
    vid.addEventListener('timeupdate', function () {
      if (vid.duration && vid.currentTime >= vid.duration * 0.62) showBar();
    });
    vid.addEventListener('ended', showBar);
    // 兜底:视频万一没播起来,9 秒后也必须给出订阅框
    setTimeout(showBar, 9000);
    initSubscribe();
    return;   // 移动端到此为止,不加载 canvas 动画
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canFilter = (function () {
    var c = document.createElement('canvas').getContext('2d');
    c.filter = 'hue-rotate(10deg)';
    return c.filter === 'hue-rotate(10deg)';
  })();

  // ------------------------------------------------------------------ state
  var S = {
    lx: SWEEP_X0, ly: ROWS[0],   // light top-left, design coords
    embossA: 0,                  // dark embossed plate
    lightA: 0,                   // moving light layer
    glowA: 0,                    // pre-blurred green halo
    baseA: 1,                    // green layer level (dimmed at rest so the
                                 // pointer light visibly "ignites" glyphs)
    coreA: 0,                    // white-hot core under the pointer
    sceneA: 0,                   // torch-boosted scene glow around the light
    sceneBase: 0,                // lower half of the scene (the city skyline)
    sceneTop: 0,                 // upper half of the scene (castle in the clouds)
    hue: 0,                      // pointer-driven hue shift (deg)
    floor: 0                     // reveal floor stamped into the accumulator
  };
  var lastFloor = 0;
  var lastStamp = null;          // last accumulated light position
  var dirty = true;
  var interactive = false;      // becomes true once the intro finishes
  var booted = false;           // assets decoded, timeline exists
  var skipQueued = false;       // visitor clicked while still loading
  var box = { x: 0, y: 0, w: 0, h: 0, k: 1 };
  var dpr = Math.min(window.devicePixelRatio || 1, 2);

  // ------------------------------------------------------------ offscreens
  function off(w, h) {
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    return c;
  }
  var acc = off(LW, LH), accX = acc.getContext('2d');       // reveal accumulator (alpha)
  var greenC = off(LW, LH), greenX = greenC.getContext('2d');
  var lightC = off(LW, LH), lightX = lightC.getContext('2d');
  var sceneC = off(2, 2), sceneX = sceneC.getContext('2d'); // torch-lit scene (half-res)
  var maskTop = null, maskBot = null;                       // zone gradients (built in layout)

  var img = {};
  var maskData = null;

  function loadImage(name) {
    return new Promise(function (res, rej) {
      var i = new Image();
      i.onload = function () { res(i); };
      i.onerror = rej;
      i.src = ASSET_MAP[name] || (ASSETS + name);
    });
  }

  // ------------------------------------------------------------- layout
  function layout() {
    var vw = window.innerWidth, vh = window.innerHeight;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    stage.width = Math.round(vw * dpr);
    stage.height = Math.round(vh * dpr);
    // strict 1:1 mapping of the 1920×1080 design frame (contain, centred):
    // at a 1920×1080 viewport every element renders at its exact design
    // size and position (plate at 412,63 — the design is NOT centred)
    var k = Math.min(vw / 1920, vh / 1080);
    var frameFit = true;
    // portrait/narrow screens only: the frame-fit logo would be tiny —
    // scale it up and centre the plate instead
    if (vh > vw && (vw * 0.92) / LW > k) {
      k = (vw * 0.92) / LW;
      frameFit = false;
    }
    box.k = k;
    box.w = LW * k; box.h = LH * k;
    if (frameFit) {
      var frameX = (vw - 1920 * k) / 2, frameY = (vh - 1080 * k) / 2;
      box.x = frameX + 408 * k;
      box.y = frameY + 59 * k;
    } else {
      box.x = (vw - box.w) / 2;
      box.y = vh * 0.40 - box.h / 2;
    }
    sceneC.width = Math.max(2, Math.round(vw / 2));
    sceneC.height = Math.max(2, Math.round(vh / 2));
    // vertical gradient masks: castle-in-the-clouds zone (top) and the
    // city-skyline zone (bottom), crossfading around the logo's text line
    var mh = sceneC.height, mw = sceneC.width;
    maskTop = off(mw, mh); maskBot = off(mw, mh);
    var gt = maskTop.getContext('2d');
    var grad = gt.createLinearGradient(0, 0, 0, mh);
    grad.addColorStop(0, 'rgba(255,255,255,1)');
    grad.addColorStop(0.48, 'rgba(255,255,255,1)');
    grad.addColorStop(0.68, 'rgba(255,255,255,0)');
    gt.fillStyle = grad; gt.fillRect(0, 0, mw, mh);
    var gb = maskBot.getContext('2d');
    grad = gb.createLinearGradient(0, 0, 0, mh);
    grad.addColorStop(0.42, 'rgba(255,255,255,0)');
    grad.addColorStop(0.62, 'rgba(255,255,255,1)');
    grad.addColorStop(1, 'rgba(255,255,255,1)');
    gb.fillStyle = grad; gb.fillRect(0, 0, mw, mh);
    // 订阅框 = 客户新设计（荆棘边框，图片宽高比 3.857）。
    // 保持原设计的水平中心与底部基线：Component 33 在帧 (844,911) 232×37,
    // 中心 x=960、底 y=948。新框宽 333(设计单位)、高 333/3.857=86.3。
    var uiBox = document.getElementById('ui');
    if (uiBox) {
      var bw = 333 * k, bh = bw / 3.857;
      var cx, by;
      if (frameFit) {
        var fx0 = (vw - 1920 * k) / 2, fy0 = (vh - 1080 * k) / 2;
        cx = fx0 + 960 * k;
        by = fy0 + 948 * k;
      } else {
        cx = vw / 2;
        by = box.y + box.h + 92 * k;
      }
      uiBox.style.left = (cx - bw / 2) + 'px';
      uiBox.style.top = (by - bh) + 'px';
      uiBox.style.width = Math.round(bw) + 'px';
      uiBox.style.height = Math.round(bh) + 'px';
      uiBox.style.transform = 'none';
    }
    var subInput = document.getElementById('sub-input');
    if (subInput) subInput.style.fontSize = Math.max(14, Math.round(21 * k)) + 'px';
  }

  // 手电筒光心的屏幕坐标（sceneA 光圈揭示背景用）
  function torchPos() {
    var bx = S.lx + OFF_X + LIGHT_W * BLOB_X;
    var by = S.ly + OFF_Y + LIGHT_H * BLOB_Y;
    return { x: box.x + bx * box.k, y: box.y + by * box.k };
  }

  function render() {
    // flashlight beam centre/radius in plate coords — everything the
    // pointer light does is clipped inside this circle, so only the spot
    // under the mouse lights up
    var BEAM = 200;
    var bx = S.lx + OFF_X + LIGHT_W * BLOB_X;
    var by = S.ly + OFF_Y + LIGHT_H * BLOB_Y;

    // the client's fully-lit speckled logo lives only inside the beam:
    // wherever the pointer's light circle lands, that part of the lit
    // artwork shows; outside the beam the logo stays dark embossed
    greenX.globalCompositeOperation = 'source-over';
    greenX.clearRect(0, 0, LW, LH);
    if (S.lightA > 0.01 && img.lit && torchTex) {
      greenX.drawImage(img.lit, 0, 0, LW, LH);
      greenX.globalCompositeOperation = 'destination-in';
      greenX.drawImage(torchTex, bx - BEAM, by - BEAM, BEAM * 2, BEAM * 2);
    }

    // ---- composite to screen ----
    var vw = stage.width / dpr, vh = stage.height / dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, vw, vh);

    // castle scene, laid out exactly as the design's full-bleed 背景
    // composite. Two hover zones: castle-in-the-clouds (top) and city
    // skyline (bottom), plus a torch boost around the pointer light.
    if ((S.sceneBase > 0.01 || S.sceneTop > 0.01 || S.sceneA > 0.01) && img.scene) {
      var sw = sceneC.width, sh = sceneC.height;
      var sc = Math.max(sw / img.scene.width, sh / img.scene.height);
      var dw = img.scene.width * sc, dh = img.scene.height * sc;
      var scenePass = function (mask, alpha) {
        sceneX.globalCompositeOperation = 'source-over';
        sceneX.clearRect(0, 0, sw, sh);
        sceneX.drawImage(img.scene, (sw - dw) / 2, (sh - dh) / 2, dw, dh);
        sceneX.globalCompositeOperation = 'destination-in';
        if (mask) sceneX.drawImage(mask, 0, 0);
        ctx.globalCompositeOperation = 'screen';
        ctx.globalAlpha = alpha;
        ctx.drawImage(sceneC, 0, 0, vw, vh);
      };
      if (S.sceneTop > 0.01 && maskTop) {
        scenePass(maskTop, S.sceneTop);
        // extra additive lift — the cloud castle is intrinsically dim in
        // the source art; this pulls it out of the murk like the design
        // frames, where ambient mist glow brightens the whole sky
        ctx.globalCompositeOperation = 'lighter';
        ctx.globalAlpha = S.sceneTop * 0.35;
        ctx.drawImage(sceneC, 0, 0, vw, vh);
      }
      if (S.sceneBase > 0.01 && maskBot) scenePass(maskBot, S.sceneBase);
      if (S.sceneA > 0.01 && torchTex) {
        sceneX.globalCompositeOperation = 'source-over';
        sceneX.clearRect(0, 0, sw, sh);
        sceneX.drawImage(img.scene, (sw - dw) / 2, (sh - dh) / 2, dw, dh);
        var tp = torchPos();
        var r = Math.max(430 * box.k, 0.36 * Math.min(vw, vh));
        sceneX.globalCompositeOperation = 'destination-in';
        sceneX.drawImage(torchTex, tp.x / 2 - r / 2, tp.y / 2 - r / 2, r, r);
        ctx.globalCompositeOperation = 'screen';
        ctx.globalAlpha = S.sceneA;
        ctx.drawImage(sceneC, 0, 0, vw, vh);
      }
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
    }

    if (S.embossA > 0.01) {
      // 'screen' so the plate's black never blots out a torch-lit scene
      ctx.globalCompositeOperation = 'screen';
      ctx.globalAlpha = S.embossA;
      ctx.drawImage(img.emboss, box.x, box.y, box.w, box.h);
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
    }

    ctx.globalCompositeOperation = 'screen';
    ctx.globalAlpha = Math.min(1, S.lightA);
    ctx.drawImage(greenC, box.x, box.y, box.w, box.h);
    // second additive pass so the lit artwork pops at full "全亮" punch
    // inside the beam
    ctx.globalCompositeOperation = 'lighter';
    ctx.globalAlpha = Math.min(1, S.lightA) * 0.5;
    ctx.drawImage(greenC, box.x, box.y, box.w, box.h);
    ctx.globalAlpha = 1;

    if (S.glowA > 0.01) {
      ctx.globalAlpha = S.glowA;
      if (canFilter && S.hue !== 0) ctx.filter = 'hue-rotate(' + S.hue.toFixed(1) + 'deg)';
      ctx.drawImage(img.glow, box.x, box.y, box.w, box.h);
      ctx.filter = 'none';
    }
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'source-over';
  }

  // draw only when something changed; rAF idles otherwise (kind to the GPU)
  function tick() {
    if (dirty) {
      dirty = false;
      render();
    }
    requestAnimationFrame(tick);
  }
  gsap.ticker.add(function () {
    if (gsap.globalTimeline.isActive()) dirty = true;
  });

  // ------------------------------------------------------------- timeline
  var tl = null;

  function buildTimeline() {
    tl = gsap.timeline({
      paused: true,
      defaults: { ease: 'none' },
      onUpdate: function () { dirty = true; },
      onComplete: enterInteractive
    });

    // Default resting state = the dark embossed logo (storyboard 未标题-1),
    // no glow, no light. Green and light exist only under the visitor's
    // pointer. At the 4s mark only COMING SOON arrives.
    tl.to(S, { embossA: 0.25, duration: 0.9, ease: 'power2.out' }, 0);
    if (ui.hint) tl.to(ui.hint, { autoAlpha: 1, duration: 0.6 }, 0.4);

    // per the design note: the subscribe bar fades in (渐变) at the 3s mark
    tl.addLabel('bloom', 3.0);
    tl.to(ui.coming, { autoAlpha: 1, duration: 1.1, ease: 'power2.inOut' }, 'bloom');
    if (ui.btn) tl.to(ui.btn, { autoAlpha: 1, y: 0, duration: 0.9, ease: 'power2.out' }, 'bloom+=1.15');
    if (ui.hint) tl.to(ui.hint, { autoAlpha: 0, duration: 0.4 }, 'bloom');

    return tl;
  }

  function finishInstantly() {
    if (tl) tl.kill();
    gsap.set(S, { embossA: 0.25, lightA: 0, coreA: 0, sceneA: 0, sceneBase: 0, sceneTop: 0, glowA: 0, baseA: 1 });
    gsap.set(uiEls, { autoAlpha: 1, y: 0 });
    if (ui.hint) gsap.set(ui.hint, { autoAlpha: 0 });
    enterInteractive();
    dirty = true;
  }

  // ------------------------------------------------------- interactivity
  var idleTimer = null;

  function enterInteractive() {
    interactive = true;
  }

  function pointerToLocal(e) {
    var r = stage.getBoundingClientRect();
    return {
      x: (e.clientX - r.left - box.x) / box.k,
      y: (e.clientY - r.top - box.y) / box.k
    };
  }

  function insideLogo(p) {
    if (!maskData || p.x < 0 || p.y < 0 || p.x >= LW || p.y >= LH) return false;
    return maskData[(Math.floor(p.y) * LW + Math.floor(p.x)) * 4 + 3] > 40;
  }

  // generous hover zone: the logo's visual bounding region (the hollow of
  // the C counts as "on the logo" — the edge glow should answer there too)
  function nearLogo(p) {
    return p.x > 130 && p.x < 1100 && p.y > 40 && p.y < 800;
  }

  function onPointerMove(e) {
    if (!booted) return;
    var p = pointerToLocal(e);
    var onGlyph = insideLogo(p);
    var over = nearLogo(p);
    // above the logo's text line: pitch black except the flashlight spot
    // on the logo itself — the beam never lights the background there.
    // Below the text line: the city skyline surfaces full-width.
    var zoneBottom = p.y > LH * 0.7;
    // aim the bright mass of the texture at the pointer (design coords)
    var tx = p.x - LIGHT_W * BLOB_X - OFF_X;
    var ty = p.y - LIGHT_H * BLOB_Y - OFF_Y;
    gsap.to(S, {
      lx: tx, ly: ty,
      lightA: over ? 1 : 0.55,
      coreA: 0,
      baseA: over ? 1 : 0.88,
      sceneTop: zoneBottom ? 0.75 : 0,
      sceneBase: zoneBottom ? 0.75 : 0,
      // 光圈内揭示"全亮世界"：背景场景跟着手电筒亮起来，
      // 不再只是灰浮雕 + 暗绿斑点
      sceneA: 0.9,
      // the design's light texture is plain green — no colour shift
      hue: 0,
      duration: 0.6, ease: 'power2.out', overwrite: 'auto'
    });
    // no whole-logo glow: the flashlight model lights only what the
    // beam touches, nothing else

    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      gsap.to(S, { lightA: 0, coreA: 0, sceneA: 0, sceneBase: 0, sceneTop: 0, hue: 0, glowA: 0, baseA: 1, duration: 1.4, ease: 'power2.inOut' });
    }, 1500);
  }

  function skipIntro() {
    if (interactive) return;
    if (booted) finishInstantly();
    else skipQueued = true;
  }

  // --------------------------------------------------------------- boot
  var coreTex = null;
  var torchTex = null;
  function makeCore() {
    var c = off(340, 340), g = c.getContext('2d');
    var grad = g.createRadialGradient(170, 170, 0, 170, 170, 170);
    grad.addColorStop(0, 'rgba(235,255,240,0.9)');
    grad.addColorStop(0.25, 'rgba(140,255,170,0.5)');
    grad.addColorStop(1, 'rgba(60,220,110,0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, 340, 340);
    return c;
  }
  function makeTorch() {
    var c = off(512, 512), g = c.getContext('2d');
    var grad = g.createRadialGradient(256, 256, 0, 256, 256, 256);
    grad.addColorStop(0, 'rgba(255,255,255,1)');
    grad.addColorStop(0.55, 'rgba(255,255,255,0.55)');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, 512, 512);
    return c;
  }

  Promise.all([
    loadImage('logo-emboss.png'),
    loadImage('logo-lit.png'),
    loadImage('logo-mask.png'),
    loadImage('logo-glow.png'),
    loadImage('bg-castle.jpg')
  ]).then(function (res) {
    img.emboss = res[0];
    img.lit = res[1];
    img.mask = res[2];
    img.glow = res[3];
    img.scene = res[4];
    torchTex = makeTorch();

    // silhouette lookup table for hover hit-testing
    var mc = off(LW, LH), mx = mc.getContext('2d', { willReadFrequently: true });
    mx.drawImage(img.mask, 0, 0, LW, LH);
    maskData = mx.getImageData(0, 0, LW, LH).data;

    layout();
    gsap.set(uiEls, { autoAlpha: 0 });
    requestAnimationFrame(tick);

    booted = true;
    if (reduceMotion || skipQueued) {
      finishInstantly();
    } else {
      buildTimeline().play();
    }
  }).catch(function (err) {
    // if any asset fails, never trap the visitor on a black screen
    console.error('intro assets failed, skipping animation', err);
    interactive = true; // disarm the skip path
    document.getElementById('stage').style.display = 'none';
    uiEls.forEach(function (el) {
      el.style.opacity = 1;
      el.style.visibility = 'visible';
    });
    if (ui.hint) ui.hint.style.opacity = 0;
  });

  window.addEventListener('resize', layout);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) gsap.globalTimeline.pause();
    else { gsap.globalTimeline.play(); dirty = true; }
  });
  document.getElementById('intro').addEventListener('pointermove', onPointerMove);
  document.getElementById('intro').addEventListener('click', skipIntro);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') skipIntro();
  });
  if (ui.btn) {
    ui.btn.addEventListener('click', function () {
      var teaser = document.getElementById('teaser');
      if (teaser) teaser.scrollIntoView({ behavior: 'smooth' });
    });
  }

  // 订阅提交：完全由 JS 接管，页面永不重载。移动/桌面共用。
  // ⚠️ 关键：不能用 Shopify 的 {% form 'customer' %}——它会挂载人机验证脚本，
  // 验证通过后 captcha 会调用原生 form.submit()，绕过 submit 事件监听导致整页
  // POST 重载（动画重头播）。这里用普通 form + 手动 fetch，captcha 不介入。
  function initSubscribe() {
  var subForm = document.getElementById('subscribe');
  var submitted = false;
  // 验证流程回跳落地:直接呈现「已订阅」终态,像从未离开过
  if (/[?&](subscribed=1|customer_posted=true)/.test(location.search)) {
    submitted = true;
    var doneInput = document.getElementById('sub-input');
    if (doneInput && subForm) {
      doneInput.value = subForm.getAttribute('data-done-text') || 'Secrets unlocked';
      doneInput.readOnly = true;
    }
  }
  if (subForm) {
    subForm.addEventListener('submit', function (e) {
      var input = document.getElementById('sub-input');
      if (input && (!input.value || !input.checkValidity())) {
        e.preventDefault();
        if (input.reportValidity) input.reportValidity();
        return;
      }
      // 本地演示(无liquid环境):拦下并演示文字渐变
      if (subForm.getAttribute('data-real') !== '1') {
        e.preventDefault();
        setTimeout(swapSubText, 350);
      }
      // 正式环境:不拦截——Shopify 官方 captcha 必须接管原生提交
      // 才能带上验证码令牌;成功后 302 回 /?subscribed=1 呈现终态
      var btn = document.getElementById('sub-btn');
      if (btn) {
        gsap.fromTo(btn, { x: 0 }, {
          x: 6, duration: 0.16, ease: 'power2.in',
          yoyo: true, repeat: 1, overwrite: 'auto'
        });
      }
    });
  }
  }
  initSubscribe();

  // 提交成功后：框内文字渐变过渡成另一段文字（正式文案待客户定，
  // 先用表单 data-done-text 上的占位词，换词只改一个属性）
  function swapSubText() {
    var input = document.getElementById('sub-input');
    var form = document.getElementById('subscribe');
    if (!input) return;
    var done = (form && form.getAttribute('data-done-text')) || 'Subscribed';
    input.blur();
    // 同时动画 color 和 -webkit-text-fill-color：后者是自动填充时
    // 唯一生效的文字着色通道，只动 color 会看不到渐变
    var fade = { a: 1 };
    gsap.to(fade, {
      a: 0, duration: 0.7, ease: 'power1.in',
      onUpdate: function () {
        var c = 'rgba(173,173,173,' + fade.a.toFixed(3) + ')';
        input.style.color = c;
        input.style.webkitTextFillColor = c;
      },
      onComplete: function () {
        input.value = done;
        input.readOnly = true;
        // 换词后清掉自动填充状态，避免浏览器再刷背景
        input.setAttribute('autocomplete', 'off');
        gsap.to(fade, {
          a: 1, duration: 1.0, ease: 'power1.out',
          onUpdate: function () {
            var c2 = 'rgba(173,173,173,' + fade.a.toFixed(3) + ')';
            input.style.color = c2;
            input.style.webkitTextFillColor = c2;
          }
        });
      }
    });
  }

  // debug/testing handle (harmless in production)
  window.__utc = {
    state: S,
    timeline: function () { return tl; },
    seek: function (t) { if (tl) { tl.pause(); tl.time(t); dirty = true; } },
    finish: finishInstantly,
    box: function () { return box; },
    replay: function () {
  
      accX.globalCompositeOperation = 'source-over';
      accX.clearRect(0, 0, LW, LH);
      lastFloor = 0;
      lastStamp = null;
      interactive = false;
      gsap.set(S, { coreA: 0, hue: 0 });
      gsap.set(uiEls, { autoAlpha: 0 });
      if (tl) tl.restart();
      dirty = true;
    }
  };
})();
